import { BasicInfo, Language, UserProfile, UserRoleName } from '@brands/services/identity/types/UserProfile';
import { parsePhoneNumber } from 'libphonenumber-js';

import { MyProfileSubmit } from '../../utils/types';
import { areArraysEqual } from '../../utils/utilsFunctions';

export const shouldUpdateUser = (user: UserProfile, profileData: MyProfileSubmit): boolean => {
  const { address1, address2, city, state, zip_code, phone_number: newPhoneNumber } = profileData;

  const formattedPhoneNumber = parsePhoneNumber(newPhoneNumber, 'US')?.format('E.164') || '';

  const hasAddressChanged =
    user?.address?.address1 !== address1 ||
    user?.address?.address2 !== address2 ||
    user?.address?.city !== city ||
    user?.address?.state !== state ||
    user?.address?.zip_code !== zip_code;

  const hasPhoneChanged = user?.phone_number !== formattedPhoneNumber;

  return hasAddressChanged || hasPhoneChanged;
};

export function hasBasicInfoChanged(currentUser: UserProfile, newData: BasicInfo): boolean {
  const normalizeLanguages = (langs: Language[] | string[] = []) =>
    langs.map((lang: any) => (typeof lang === 'string' ? lang : lang.id?.toString())).sort();

  const currentLanguages = normalizeLanguages(currentUser.basic_info?.languages || []);
  const newLanguages = normalizeLanguages(newData.languages || []);

  const basic = currentUser.basic_info;

  return (
    basic?.first_name !== newData.first_name ||
    basic?.middle_name !== newData.middle_name ||
    basic?.last_name !== newData.last_name ||
    basic?.date_of_birth !== newData.date_of_birth ||
    basic?.gender !== newData.gender ||
    basic?.pronouns !== newData.pronouns ||
    basic?.gender_identity !== newData.gender_identity ||
    JSON.stringify(currentLanguages) !== JSON.stringify(newLanguages)
  );
}
